import { i18n } from 'i18n';

export const ROUTE_PATH = '/reports';
export const TITLE = i18n._('Reports');
